<template>
  <PopupPicker
    v-model:show="innerShow"
    title="选择故障类型"
    :columns="columns"
    :columns-field-names="{
      text: 'faulttype',
      value: 'id',
      children: 'lists'
    }"
    @search="onSearch"
    @confirm="onConfirm"
    @open="getColumns"
  />
</template>

<script setup>
import { ref } from "vue";
import { repairService } from "@/service";
import { Toast } from "vant";
import { useVModel } from "@vueuse/core";
import PopupPicker from "@/components/PopupPicker/Picker.vue";

const props = defineProps({
  show: { default: false }
});

const columns = ref([]);

const emit = defineEmits(["update:show", "confirm"]);
const innerShow = useVModel(props, "show", emit);

const getColumns = async () => {
  try {
    const { data } = await repairService.getFaultType({ pagesize: 99999, more: "1" });
    columns.value = data.data;
  } catch {
    columns.value = [];
  }
};

const onSearch = async value => {
  if (value === "") return getColumns();
  try {
    const { data } = await repairService.searchFaultType({ search_name: value });
    columns.value = data.data;
  } catch {
    columns.value = [];
  }
};

const onConfirm = selectedValue => {
  if (selectedValue.length === 0) return Toast.fail("请选择故障类型");
  innerShow.value = false;
  emit("confirm", selectedValue[0]);
};
</script>
